import React, { useState } from "react";
import axios from "axios";
import "./Weather.css";
import { MagnifyingGlass } from 'react-loader-spinner';
import WeatherInfo from "./WeatherInfo";
import WeatherForecast from "./WeatherForecast"


export default function Weather (props){
    const [weatherData, setWeatherData] = useState({ready: false});
    const [city, setCity]= useState(props.defaultCity)

   function displayWeather(response) {
    console.log(response.data);
    setWeatherData({
      ready: true,
      coordinates: response.data.coord,
      temperature: response.data.main.temp,
      date: new Date(response.data.dt*1000),
      city: response.data.name,
      wind: Math.round(response.data.wind.speed),
      humidity: response.data.main.humidity,
      icon: response.data.weather[0].icon,
      description: response.data.weather[0].description,
      maxTemp: response.data.main.temp_max,
      minTemp: response.data.main.temp_min,
      feelsLike: response.data.main.feels_like,
   
    });
   }
    function search(){
  const apiKey = `d1a86552de255334f6117b348c4519bd`;
        let url = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
     axios.get(url).then(displayWeather);
    }

function handleSubmit(event) {
  event.preventDefault();
  search();
}
function handleCityChange(event){
setCity(event.target.value);
}
   if (weatherData.ready){
  return (
     <div className="Weather">
       <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-auto">
             <input
        className="form-control"
        type="search"
        placeholder="Enter a city..."
        debounceTimeout={500}
        autoFocus="on"
        onChange={handleCityChange}
         />
       </div>
          <div className="col-auto">
             <button type="submit" className="searchButton btn btn-primary">
                Search🔎
              </button>
      </div>   
      </div>
      </form>
      <WeatherInfo data={weatherData} />
      <WeatherForecast coordinates={weatherData.coordinates}/>
     </div>
  );    
  }else{
    search();
          return(
      <MagnifyingGlass
  visible={true}
  height="70"
  width="70"
  ariaLabel="MagnifyingGlass-loading"
  wrapperStyle={{}}
  wrapperClass="MagnifyingGlass-wrapper"
  glassColor = '#c0efff'
  color = '#e15b64'
/>
     )
  }
 }

